import { render } from "./GameDesignerPage.vue?vue&type=template&id=22849cb8&scoped=true"
import script from "./GameDesignerPage.vue?vue&type=script&lang=js"
export * from "./GameDesignerPage.vue?vue&type=script&lang=js"

import "./GameDesignerPage.vue?vue&type=style&index=0&id=22849cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22849cb8"]])

export default __exports__